module.exports = __webpack_public_path__ + "img/Dahlia.4b666dcd.jpg";